import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteUnitPlan = async (planId: string): Promise<boolean> =>
  axios.delete(`/management/unitplan/removeunitplan?planId=${planId}`).then((res) => res?.data?.result)

type Props = {
  planId: string
}

export const useManagementDeleteUnitPlan = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteUnitPlan'],
    mutationFn: ({ planId }: Props) => deleteUnitPlan(planId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted device plan.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete device plan, please try again.')
      }
    },
    throwOnError: false
  })
